import {
  PieChart, Pie, Cell,
  BarChart, Bar,
  XAxis, YAxis, Tooltip,
  ResponsiveContainer
} from "recharts";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const Admin = () => {
  

  const [cityFilter, setCityFilter] = useState("");
  const [sourceFilter, setSourceFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [leads, setLeads] = useState([]);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [showPasswordBox, setShowPasswordBox] = useState(false);
  const [newPassword, setNewPassword] = useState("");

  const [newLead, setNewLead] = useState({
    name: "", phone: "", email: "", city: "", service: "", type: "Solar"
  });

  const BLUE = "#2563eb";

  // 🔐 LOGOUT
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/admin";
  };

  // 📥 EXPORT
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredLeads);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Leads");
    saveAs(new Blob([XLSX.write(wb, { type: "array", bookType: "xlsx" })]), "Leads.xlsx");
  };

  // ➕ ADD LEAD
 const handleAddLead = () => {
  if (!newLead.name || !newLead.phone) return alert("Name & Phone required");

  const newEntry = {
    ...newLead,
    status: "New",
    source: newLead.type,
    createdAt: new Date().toISOString()
  };

  const updated = [newEntry, ...(leads || [])];

  setLeads(updated);

  // 🔥 SAVE ONLY MANUAL LEADS
  const saved = JSON.parse(localStorage.getItem("leads") || "[]");
  localStorage.setItem("leads", JSON.stringify([newEntry, ...saved]));

  setShowModal(false);
  setNewLead({ name:"",phone:"",email:"",city:"",service:"",type:"Solar" });
};
  // 📡 FETCH
useEffect(() => {
  const load = async () => {
    try {
      const c = await fetch("https://cngtpl-solar-backend.onrender.com/api/contact");
      const l = await fetch("https://cngtpl-solar-backend.onrender.com/api/leads");

      const contact = await c.json();
      const leadsData = await l.json();

      const apiData = [
        ...contact.map(x => ({
          ...x,
          type: "Software",
          source: "Main Website",
          status: "New",
          createdAt: x.submitted_at
            ? new Date(x.submitted_at).toISOString()
            : new Date().toISOString(),
          service: x.service || "Software Inquiry",
          message: x.message || x.comment || "",
        })),

        ...leadsData.map(x => {

  const bill = x.monthly_bill || x.bill || "";
  let kw = x.system_size || x.kw || "";

  // 🔥 extract from message if needed
  let message = x.message || "";

  if (!kw && message.includes("kW")) {
    const match = message.match(/([\d.]+)\s?kW/);
    if (match) kw = match[1];
  }

  return {
    ...x,
    type: "Solar",
    source: "Solar Website",
    status: "New",
    createdAt: x.created_at
      ? new Date(x.created_at).toISOString()
      : new Date().toISOString(),

    service: x.requirement || "Solar Inquiry",
    bill,
    kw,
    message
  };
})
      ];

      // 🔥 LOAD LOCAL STORAGE ALSO
      const saved = JSON.parse(localStorage.getItem("leads") || "[]");

      // 🔥 MERGE BOTH
      const finalData = [...saved, ...apiData].reverse();

      setLeads(finalData);

    } catch (err) {
      console.log("API ERROR:", err);
      setLeads([]);
    }
  };

  load();
}, []);

  // 🔍 FILTER (FIXED)
const filteredLeads = (leads || []).filter(l => {

  const matchSearch =
    l.name?.toLowerCase().includes(search.toLowerCase()) ||
    l.phone?.includes(search) ||
    l.email?.toLowerCase().includes(search.toLowerCase());

  const d = new Date(l.createdAt || new Date());

  const matchFrom = fromDate ? d >= new Date(fromDate) : true;
  const matchTo = toDate ? d <= new Date(toDate + "T23:59:59") : true;

  const matchCity = cityFilter ? l.city === cityFilter : true;
  const matchSource = sourceFilter ? l.source === sourceFilter : true;
  const matchStatus = statusFilter ? l.status === statusFilter : true;

  return matchSearch && matchFrom && matchTo && matchCity && matchSource && matchStatus;
}); 
  
  // 📊 GRAPH DATA (FIXED POSITION)
  const leadsByDate = Object.values(
  (filteredLeads || []).reduce((acc, lead) => {
      const date = new Date(lead.createdAt).toLocaleDateString();

      acc[date] = acc[date] || { date, count: 0 };
      acc[date].count++;

      return acc;
    }, {})
  );
  const pieData = [
  { name: "Main", value: filteredLeads?.filter(l=>l.source==="Main Website").length || 0 },
  { name: "Solar", value: filteredLeads?.filter(l=>l.source==="Solar Website").length || 0 }
];
if (!leads) return <div>Loading...</div>;
  return (
    <div style={{ padding: 20, background: "#f1f5f9", minHeight: "100vh" }}>

      {/* HEADER */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 20 }}>
        <h2>⚡ CRM Dashboard</h2>

        <div style={{ display: "flex", gap: 10 }}>
          <button style={btnYellow} onClick={()=>setShowModal(true)}>+ Add Lead</button>
          <button style={btnBlue} onClick={()=>setShowPasswordBox(true)}>Change Password</button>
          <button style={btnRed} onClick={handleLogout}>Logout</button>
          <button style={btnBlue} onClick={()=>window.location.reload()}>
          Refresh
          </button>        
        </div>
      </div>
      <div style={kpiContainer}>
  <KPI title="Total Leads" value={filteredLeads.length} color="#3b82f6" />
  <KPI title="Main Website" value={filteredLeads.filter(l=>l.source==="Main Website").length} color="#10b981" />
  <KPI title="Solar Website" value={filteredLeads.filter(l=>l.source==="Solar Website").length} color="#f59e0b" />
  <KPI title="Closed" value={filteredLeads.filter(l=>l.status==="Closed").length} color="#ef4444" />
  <KPI title="Conversion %" value={
    filteredLeads.length
      ? ((filteredLeads.filter(l=>l.status==="Closed").length / filteredLeads.length)*100).toFixed(1)
      : 0
  } color="#8b5cf6" />
</div>

      {/* FILTER */}
      <div style={filterBox}>
        <input placeholder="Search..." style={input} onChange={e=>setSearch(e.target.value)} />
        <input type="date" style={input} onChange={e=>setFromDate(e.target.value)} />
        <input type="date" style={input} onChange={e=>setToDate(e.target.value)} />

        <select style={input} onChange={(e)=>setCityFilter(e.target.value)}>
          <option value="">All Cities</option>
          {[...new Set(leads.map(l => l.city))].map((c,i)=>(
            <option key={i}>{c}</option>
          ))}
        </select>

        <select style={input} onChange={(e)=>setSourceFilter(e.target.value)}>
          <option value="">All Source</option>
          <option>Main Website</option>
          <option>Solar Website</option>
        </select>
        <select style={input} onChange={(e)=>setStatusFilter(e.target.value)}>
        <option value="">All Status</option>
        <option>New</option>
        <option>Contacted</option>
        <option>Closed</option>
        <option>Dropped</option>
        </select>

        <button style={btnBlue} onClick={exportToExcel}>Export</button>
      </div>

      {/* CHARTS */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 2fr", gap:20, marginBottom:20 }}>

  {/* 🥧 PIE CHART */}
  <div style={chartCard}>
    <h4>📊 Lead Sources</h4>
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={pieData}
          dataKey="value"
          outerRadius={90}
          label
        >
          <Cell fill="#3b82f6" />
          <Cell fill="#facc15" />
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  </div>

  {/* 📊 BAR CHART */}
  <div style={chartCard}>
    <h4>📊 Leads by Date</h4>
    <ResponsiveContainer width="100%" height={250}>
      {leadsByDate.length > 0 && (
      <BarChart data={leadsByDate}>
        <XAxis dataKey="date"/>
        <YAxis/>
        <Tooltip/>
        <Bar dataKey="count" fill="#10b981" radius={[6,6,0,0]} />
      </BarChart>
      )}
    </ResponsiveContainer>
  </div>

</div>
    

      {/* TABLE */}
      <table style={table}>
          <thead style={{ background: BLUE, color: "white" }}>
            <tr>
            <th>Date</th>
            <th>Name</th>
            <th>City</th>
            <th>Service</th>
            <th>Bill</th>
            <th>kW</th>
            <th>Message</th>
            <th>Source</th>
            <th>Status</th> {/* ✅ LAST */}
            </tr>
            </thead>

        
          <tbody>
  {(filteredLeads || []).map((l,i)=>(
    <tr key={i}>
      <td>{new Date(l.createdAt).toLocaleString()}</td>
      <td>{l.name}</td>
      <td>{l.city}</td>
      <td>{l.service || "-"}</td>

      {/* ✅ CLEAN DATA SPLIT */}
      <td>{l.bill || "-"}</td>
      <td>{l.kw || "-"}</td>

      <td style={{maxWidth:200}}>
        {l.message || "-"}
      </td>

      <td>{l.source}</td>

      {/* ✅ STATUS LAST */}
      <td>
        <select
          value={l.status}
          onChange={(e)=>{
            const updated = leads.map((item, idx) =>
              idx === i ? { ...item, status: e.target.value } : item
            );
            setLeads(updated);
            localStorage.setItem("leads", JSON.stringify(updated));
          }}
          style={statusStyle(l.status)}
        >
          <option>New</option>
          <option>Contacted</option>
          <option>Closed</option>
          <option>Dropped</option>
        </select>
      </td>
    </tr>
  ))}
</tbody>
</table>

      {/* ADD LEAD MODAL */}
      {showModal && (
        <div style={overlay}>
          <div style={card}>
            <h3>➕ Add Lead</h3>

            <input placeholder="Name" style={input} onChange={e=>setNewLead({...newLead,name:e.target.value})}/>
            <input placeholder="Phone" style={input} onChange={e=>setNewLead({...newLead,phone:e.target.value})}/>
            <input placeholder="Email" style={input} onChange={e=>setNewLead({...newLead,email:e.target.value})}/>
            <input placeholder="City" style={input} onChange={e=>setNewLead({...newLead,city:e.target.value})}/>
            <input placeholder="Service" style={input} onChange={e=>setNewLead({...newLead,service:e.target.value})}/>

            <select style={input} onChange={e=>setNewLead({...newLead,type:e.target.value})}>
              <option>Solar</option>
              <option>Software</option>
            </select>

            <button style={btnGradient} onClick={handleAddLead}>Save Lead</button>
            <button style={btnCancel} onClick={()=>setShowModal(false)}>Cancel</button>
          </div>
        </div>
      )}

      {/* PASSWORD MODAL */}
      {showPasswordBox && (
        <div style={overlay}>
          <div style={card}>
            <h3>🔐 Change Password</h3>

            <input type="password" placeholder="New Password" style={input}
              onChange={(e)=>setNewPassword(e.target.value)}
            />

            <button style={btnGradient}
              onClick={()=>{
                localStorage.setItem("adminPass", newPassword);
                alert("Password Updated ✅");
                setShowPasswordBox(false);
              }}>
              Save
            </button>

            <button style={btnCancel} onClick={()=>setShowPasswordBox(false)}>Cancel</button>
          </div>
        </div>
      )}

    </div>
  );
};

// 🎨 STYLES
const input = { padding: 12, borderRadius: 8, border: "1px solid #ddd" };
const table = { width:"100%", background:"white", borderRadius:10, overflow:"hidden", textAlign:"left"};
const filterBox = { display:"flex", gap:10, background:"white", padding:12, borderRadius:10, marginBottom:15 };

const chartCard = { background:"white", padding:15, borderRadius:12, flex:1 };

const overlay = {
  position:"fixed",top:0,left:0,width:"100%",height:"100%",
  background:"rgba(0,0,0,0.4)",display:"flex",justifyContent:"center",alignItems:"center"
};

const card = {
  background:"white", padding:25, borderRadius:16, width:320,
  display:"flex", flexDirection:"column", gap:12
};

const btnYellow = { background:"#facc15", padding:"10px", border:"none", borderRadius:8 };
const btnBlue = { background:"#2563eb", color:"white", padding:"10px", border:"none", borderRadius:8 };
const btnRed = { background:"#ef4444", color:"white", padding:"10px", border:"none", borderRadius:8 };
const kpiContainer = {
  display:"grid",
  gridTemplateColumns:"repeat(5,1fr)",
  gap:15,
  marginBottom:20
};

const btnGradient = {
  background:"linear-gradient(90deg,#facc15,#f59e0b)",
  color:"white",
  padding:"12px",
  border:"none",
  borderRadius:10
};

const btnCancel = { background:"#f3f4f6", padding:"10px", borderRadius:10, border:"none" };

const statusStyle = (s)=>({
  padding:"5px 10px",
  borderRadius:20,
  border:"none",
  color:"white",
  background:
    s==="New" ? "#3b82f6" :
    s==="Contacted" ? "#facc15" :
    s==="Closed" ? "#16a34a" :
    "#ef4444"
});


const KPI = ({ title, value, color }) => {

  const [count, setCount] = useState(0);

  // 🔢 COUNT-UP ANIMATION
  useEffect(() => {
    let start = 0;
    const end = Number(value) || 0;

    if (start === end) return;

    let duration = 800;
    let increment = end / (duration / 16);

    const counter = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(counter);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(counter);
  }, [value]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      whileHover={{ scale: 1.05, y: -5 }}
      transition={{ duration: 0.4 }}
      style={{
        background: `linear-gradient(135deg, ${color}, #111827)`,
        color: "white",
        padding: 18,
        borderRadius: 14,
        boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer"
      }}
    >

      {/* 🔥 GLOW EFFECT */}
      <div style={{
        position: "absolute",
        width: "150%",
        height: "150%",
        background: "radial-gradient(circle, rgba(255,255,255,0.15), transparent)",
        top: "-50%",
        left: "-50%",
        transform: "rotate(25deg)"
      }} />

      <p style={{ fontSize: 13, opacity: 0.9 }}>{title}</p>

      <h2 style={{ fontSize: 28, marginTop: 5 }}>
        {count}
      </h2>

    </motion.div>
  );
};

export default Admin;